import React from "react";

import * as SC from "./CampaignJobCategory.styled";
import Section from "../Section/Section";
import { getJobCategoryName } from "../../../../../utils/Helpers";

const CampaignJobCategory = ({ jobCategoryId }) => {
  const jobCategory = jobCategoryId ? getJobCategoryName(jobCategoryId) : "";

  return (
    <Section title={"Berufsgruppe"}>
      <SC.JobCategory>{jobCategory}</SC.JobCategory>
    </Section>
  );
};

export default CampaignJobCategory;
